import React from 'react';

import {
  AutocompleteInput,
  Create,
  CreateProps,
  ReferenceInput,
  required,
  SimpleForm,
  TextInput,
} from 'react-admin';

export const PostalCodeCreate: React.FC<CreateProps> = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="postalCode" validate={required()} />
      <ReferenceInput
        alwaysOn
        label="City"
        reference="City"
        source="city_id"
        validate={required()}
      >
        <AutocompleteInput emptyText="-" optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
